import script from "./GameQuest.vue?vue&type=script&setup=true&lang=js"
export * from "./GameQuest.vue?vue&type=script&setup=true&lang=js"

import "./GameQuest.vue?vue&type=style&index=0&id=62c530dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c530dd"]])

export default __exports__